import React, { Component } from 'react';
import { Provider } from 'react-redux';

import reducer from './reducer.mjs';
import ContactSearch from './ContactSearch';
import {configureStore} from "@reduxjs/toolkit";

let store = configureStore({reducer: reducer});

const searchApp = document.getElementById('contact-search-app');

class ContactSearchApp extends Component {
  render() {
    return (
      <Provider store={store}>
        <ContactSearch {...searchApp.dataset} />
      </Provider>
    );
  }
}

export default ContactSearchApp;
